import EastIcon from '@mui/icons-material/East'
import { Box, Container,Grid,FormControlLabel,Checkbox, SnackbarCloseReason } from '@mui/material'
import { AlertColor } from '@mui/material/Alert'
import { usePostPaymentMove } from '@src/api/payment-api/move-payment-api'
import { usePayment } from '@src/api/payment-api/payments-api'
import {
  CustomButton,
  PageSpinner,
  PaymentDashboard,
  PaymentStatus,
  TitleSection,
  CustomSnackbar,
} from '@src/components'
import { ChangeEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

const MovePayment = () => {
  const { id } = useParams<{ id: string | undefined }>()
  const { t } = useTranslation()

  const [selectedDate, setSelectedDate] = useState<Date | null>(null)
  const [agreeToTerms, setAgreeToTerms] = useState(false)
  const [successMessage] = useState('')
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  })


  const [paymentData, isLoading] = usePayment(id)
  const { loanIdToUse: activeLoanId, closestPayment: paymentInfo,closedNextPayment } = paymentData ?? {}

  const [submitMovePayment, isPending] = usePostPaymentMove()
  const maxDate = paymentInfo?.plannedOnDateUTC ? new Date(paymentInfo.plannedOnDateUTC) : null;
  const [contactRequested, setContactRequested] = useState<boolean>(false)

  const handleSubmit = () => {
    if (!selectedDate || !agreeToTerms || !activeLoanId || paymentInfo?.amount === undefined) {
      setSnackbar({
        open: true,
        message: t('payment.allFieldsMustBeFilled'),
        severity: 'error',
      });
      return;
    }
    if (maxDate === null) {
      setSnackbar({
        open: true,
        message: t('payment.failedToMovePayment'), 
        severity: 'error',
      });
      return;
    }
    submitMovePayment({
      amount: paymentInfo.amount,
      actualDate: maxDate.toISOString(),
      newDate: selectedDate.toISOString(),
      contactCustomer: contactRequested,
      loanId: activeLoanId,
    })
    .then(() => {
      setSnackbar({
        open: true,
        message: t('payment.paymentSuccessfullyMoved'),
        severity: 'success',
      });
    })
    .catch(() => {
      setSnackbar({
        open: true,
        message: t('payment.failedToMovePayment'), 
        severity: 'error',
      });
    })
  }
  const handleContactRequestedChange = (event: ChangeEvent<HTMLInputElement>) => {
    setContactRequested(event.target.checked)
  }
  const handleAgreeToTermsChange = (event: ChangeEvent<HTMLInputElement>) => {
    setAgreeToTerms(event.target.checked)
  }
  const handleCloseSnackbar = (_: React.SyntheticEvent | Event, reason: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar((prevState) => ({
      ...prevState,
      open: false,
    }));
  }
  const renderSection = (title: string, state: boolean, setState: (event: ChangeEvent<HTMLInputElement>) => void) => {
    return (
      <Box sx={{ mt: '1rem' }}>
        <FormControlLabel control={<Checkbox checked={state} onChange={setState} />} label={t(title)} />
      </Box>
    )
  }
  if (isLoading || !paymentInfo) return <PageSpinner isLoading={true} />

  return (
    <>
   <TitleSection title={t('payment.titlemv')} />
    <Container component="main" sx={{ flexGrow: 1 }}>
    <Grid container>
      <Grid size={{ xs: 12, md: 9, lg: 9 }}>
      <Box sx={{ padding: { xs: '0 1px', sm: '0 20px',xl: '0 20px'},boxSizing: 'border-box'}} >
     
        <PaymentDashboard paymentInfo={paymentInfo} selectedDate={selectedDate} onDateChange={setSelectedDate}   closedNextPayment={closedNextPayment}   maxDate={paymentInfo?.plannedOnDateUTC ? new Date(paymentInfo.plannedOnDateUTC) : null}/>

        <PaymentStatus paymentInfo={paymentInfo} />

        {renderSection('payment.confirmTerms', agreeToTerms, handleAgreeToTermsChange)}
        {renderSection('payment.contactForChanges', contactRequested, handleContactRequestedChange)}

        <CustomButton
          disabled={!agreeToTerms}
          title={t('payment.titlemv')}
          onClick={handleSubmit}
          Icon={EastIcon}
          isPending={isPending}
        />

        {successMessage && <div className="success-message">{successMessage}</div>}
        </Box>
        </Grid>
     </Grid>
     </Container>
     <CustomSnackbar
      open={snackbar.open}
      message={snackbar.message}
      severity={snackbar.severity as AlertColor}
      onClose={handleCloseSnackbar}
    />
     </>
  )
}

export default MovePayment
